import React from "react";
import PropTypes from "prop-types";
import GroupAvatarsComponent from "./GroupAvatarsComponent";

export const GroupAvatarsContainer = ({
  imgSrcSet = [],
  limit = 3,
  total = 0,
  dimensions = "w-10 h-10",
  className = "",
  avatarClass = "",
  direction = "row-reverse",
  showGigIcon = false,
  labelClassName = "",
}) => {
  return (
    <GroupAvatarsComponent
      imgSrcSet={imgSrcSet}
      limit={limit}
      total={total}
      dimensions={dimensions}
      className={className}
      avatarClass={avatarClass}
      direction={direction}
      showGigIcon={showGigIcon}
      labelClassName={labelClassName}
    />
  );
};

GroupAvatarsContainer.propTypes = {
  /** The Set of avatarlinks  */
  imgSrcSet: PropTypes.arrayOf(PropTypes.string).isRequired,
  /** This is the number of avatars that will be shown */
  limit: PropTypes.number,
  /** This will add a +200 label beside the avatars. To have no labels like this, simply pass 0*/
  total: PropTypes.number,
  /** Dimensions of avatars */
  dimensions: PropTypes.string,
  /** Style the wrapper */
  className: PropTypes.string,
  /** Style the wrapper */
  avatarClass: PropTypes.string,
  /** Direction of stack of avatars */
  direction: PropTypes.oneOf([
    "row",
    "row-reverse",
    "col",
    "col-reverse",
    "diagonal",
  ]),
  /** Add Gig Icon at the end */
  showGigIcon: PropTypes.bool,
  /**This will update the classNameof the label */
  labelClassName: PropTypes.string,
};
